let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6dERU")).then(() => parcelRequire('gch8x'));